"use strict";
/*
 * Created on 10 11 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter for {@link VAT}.
 *
 * @author JMe
 */


var VATConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(VATConverter, _DataObjectConverter_);

  function VATConverter() {
    _classCallCheck(this, VATConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(VATConverter).apply(this, arguments));
  }

  return VATConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.VATConverter = VATConverter;